export default {
  category: {
    groupNo: '品类编码',
    groupName: '品类名称',
    orgNo: '组织',
    statusCode: '状态',
    remark: '备注',
    createName: '创建人员',
    createDate: '创建时间',
    updateName: '更新人员',
    updateDate: '更新时间',
    groupNoIndistinct: '品类编码',
    groupNameIndistinct: '品类名称',
    remarkIndistinct: '备注'
  },
  unit: {
    unitNo: '单位编码',
    unitName: '单位名称',
    unitType: '单位类型',
    dicimalDigit: '小数位数',
    orgNo: '组织',
    statusCode: '状态',
    remark: '备注',
    createName: '创建人员',
    createDate: '创建时间',
    updateName: '更新人员',
    updateDate: '更新时间',
    unitNoIndistinct: '单位编码',
    unitNameIndistinct: '单位名称'
  }
}
